"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '-0.5 -0.5 12 12'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Desktop",
    stroke: "currentColor",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "GUI",
    transform: "translate(-205.000000, -6069.000000)",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-29",
    transform: "translate(179.000000, 5953.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-12",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "rating-star-1",
    transform: "translate(6.000000, 7.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4089404,3.75124116 C10.2919241,3.38941652 9.97988309,3.12522355 9.60371381,3.06948708 L7.19732769,2.72230365 L6.11793905,0.551577415 C5.94949519,0.213606777 5.60436723,0 5.2267464,0 C4.84912558,0 4.50399761,0.213606777 4.33555375,0.551577415 L3.25948426,2.72163982 L0.853761981,3.06948708 C0.479461892,3.12533939 0.168525324,3.38723477 0.0498630612,3.74659434 C-0.0693872353,4.10818136 0.0291934113,4.50611685 0.30344637,4.77022121 L2.04135502,6.45369574 L1.63044384,8.83352863 C1.56659035,9.20671562 1.71990164,9.58382736 2.02603658,9.80659897 C2.33217153,10.0293706 2.73815746,10.0592543 3.07361168,9.88370872 L5.22774215,8.75785194 L7.38386411,9.88636405 C7.71954996,10.0621524 8.12591607,10.0321759 8.43217389,9.80903317 C8.73843171,9.5858904 8.89149422,9.20826111 8.82703194,8.83485629 L8.41412928,6.45435957 L10.1520379,4.77022121 C10.4245224,4.50707719 10.5240988,4.11211665 10.4089404,3.75124116 Z"
  }))))))));
});